module.exports = __webpack_public_path__ + "static/Storm-Portal-3402e5ae9a49171e2126b333c7801641.jpg";